import { css, html, unsafeCSS, nothing } from 'lit';
import styles from './accordion-card.scss?inline';
import SotbitAccordion from '@/components/accordions/default/index.js';
import { ref } from 'lit/directives/ref.js';

export default class SotbitAccordionCard extends SotbitAccordion {
    static styles = [
        SotbitAccordion.styles,
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    static properties = SotbitAccordion.properties;

    constructor() {
        super();
    }

    render() {
        return html`
            <div class="collapse">
                <div part="collapse-header" class="collapse-header">
                    <div class="header-wrapper">
                        <div class="action-left" part="action-left">
                            <slot name="action-left"></slot>
                        </div>
                        <div class="header" part="header" @click="${this._handleHeaderClick}">
                            <sotbit-icon
                                pointer
                                variant="secondary"
                                size="m"
                                icon="${this.rotateRight ? 'chevron-right' : 'arrow-down'}"
                                rotate="${this.open ? (this.rotateRight ? '90' : '180') : nothing}"
                            >
                            </sotbit-icon>
                            <slot name="header"></slot>
                        </div>
                    </div>
                    <div class="subheader" part="subheader">
                        <slot name="subheader"></slot>
                    </div>
                    <div class="action" part="action">
                        <slot name="action"></slot>
                    </div>
                </div>
                <div class="collapse-body" ${ref(this._collapseBody)}}>
                    <div class="collapse-body-inner">
                        <slot></slot>
                    </div>
                </div>
            </div>
        `;
    }
}
